// // LabelStore.ts
// type LabelListener = (label: string) => void;

// class LabelStore {
//   private label = 'Initial Label';
//   private listeners: LabelListener[] = [];

//   getLabel() {
//     return this.label;
//   }

//   updateLabel(newLabel: string) {
//     this.label = newLabel;
//     this.listeners.forEach(listener => listener(this.label));
//   }

//   subscribe(listener: LabelListener) {
//     this.listeners.push(listener);
//     listener(this.label); // call immediately
//     return () => {
//       this.listeners = this.listeners.filter(l => l !== listener);
//     };
//   }
// }

// export const labelStore = new LabelStore();



import { ReactNode } from 'react';

type LabelListener = (label: string) => void;
type IconListener = (icon: ReactNode) => void;

class LabelStore {
  private label = 'Initial Label';
  private icon: ReactNode = null;

  private labelListeners: LabelListener[] = [];
  private iconListeners: IconListener[] = [];

  // LABEL (unchanged)
  getLabel() {
    return this.label;
  }

  updateLabel(newLabel: string) {
    this.label = newLabel;
    this.labelListeners.forEach(listener => listener(this.label));
  }

  subscribe(listener: LabelListener) {
    this.labelListeners.push(listener);
    listener(this.label);
    return () => {
      this.labelListeners = this.labelListeners.filter(l => l !== listener);
    };
  }

  // 🆕 ICON SUPPORT
  getIcon() {
    return this.icon;
  }

  updateIcon(newIcon: ReactNode) {
    this.icon = newIcon;
    this.iconListeners.forEach(listener => listener(this.icon));
  }

  subscribeIcon(listener: IconListener) {
    this.iconListeners.push(listener);
    listener(this.icon);
    return () => {
      this.iconListeners = this.iconListeners.filter(l => l !== listener);
    };
  }
}

export const labelStore = new LabelStore();